import React, {
  useState,
  useContext,
  useRef,
  useEffect,
} from "react";
import { useHistory } from "react-router-dom";
import AppContextObject from "../../../../common/context/common";
import ConfirmDialog from "../../../../components/addon/confirmDialog/confirmDialog";
import BackendTopBar from "../components/backendTopBar";
import InventoryReport from "./inventoryReport";
import Loader from "../../../../components/addon/loader";
import Pagination from "../../../../components/addon/pagination";
import downloadIcon from "../../../../assets/images/download.svg";
import viewIcon from "../../../../assets/images/open-eye.svg";
import backIcon from "../../../../assets/images/back-arrow.svg";
import { is } from "date-fns/locale";

const CampaignCompetitionReportingViewLevel2 = (props) => {
  const context = useContext(AppContextObject);
  const history = useHistory();

  const [overlay, setOverlay] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [ref, setRef] = useState();
  const [formData, setFormData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [schoolId, setSchoolId] = useState<any>();
  const [campaignId, setCampaignId] = useState<any>();

  const [activeSetIndex, setActiveSetIndex] = useState(-1);
  const [activeInventoryIndex, setActiveInventoryIndex] = useState(-1);
  const [activeImageIndex, setActiveImageIndex] = useState(-1);
  const [showAllDeleteModal, setShowAllDeleteModal] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  const [multiSelectInventories, setMultiSelectInventories] = useState([]);
  const [salesViewData, setSalesViewData] = useState([]);
  const [searchKeys, setSearchKeys] = useState("");
  const [debouncedSearchKeys, setDebouncedSearchKeys] = useState("");
  const [sortAlbumDataBy, setSortAlbumDataBy] = useState("cities");
  const [location, setLocation] = useState("");
  const [selectedCities, setSelectedCities] = useState([]);
  const [openCityFilter, setOpenCityFilter] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [cityWiseData, setCityWiseData] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  
  const [totalPage, setTotalPage] = useState([0]);
  const [currentPage, setCurrentpage] = useState(1);
  const [dataPerPage] = useState(25);

  useEffect(() => {
    if (props.setShowSidemenu) {
      props.setShowSidemenu(true);
    }
    let state: any = history.location.state;
    if (
      context.user.role === "backendSales" ||
      context.user.role === "backendOperations" ||
      context.user.role === "backendAdmin" ||
      context.user.role.startsWith("brand")
    ) {
      if (
        history.location.search &&
        history.location.search.split("?").length > 1
      ) {
        let array = history.location.search.split("?");
        if (array && array.length > 1 && array[1] && array[1] !== "") {
          let data: any = array[1];
          if (data) {
            getAlbumViewForSalesLevel2(data);
          }
        }
      } else if (state.albumId) {
        getAlbumViewForSalesLevel2(state.albumId);
      }
    }
  }, [debouncedSearchKeys, selectedCities, currentPage]);

  // Reset to page 1 when filters change
  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentpage(1);
    }
  }, [debouncedSearchKeys, selectedCities]);

  // Debounced search effect - triggers search after 500ms delay when 3+ characters
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchKeys.length >= 3 || searchKeys === "") {
        setDebouncedSearchKeys(searchKeys);
        setCurrentpage(1);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchKeys]);

  // Close filter dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openCityFilter && !event.target.closest('.filterbox')) {
        setOpenCityFilter(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openCityFilter]);

const getAlbumViewForSalesLevel2 = async (campaign_id) => {
  setIsLoading(true);
  setCampaignId(campaign_id);

  try {
    let allStates: any[] = [];
    let allCities = [];
    const statesResp = await context.apis.public.getHpStatesByCountryRegion(
      context.validator,
      {},
      {}
    );


    if (statesResp?.done && statesResp?.response?.rows?.length) {
      allStates = statesResp.response.rows.flatMap((row) => row.states || []);
      allStates = Array.from(new Set(allStates)).sort((a: string, b: string) => a.localeCompare(b));
    }

    if (allStates.length === 0) {
      const citiesResp = await context.apis.public.getCitiesByCountryRegion(
        context.validator,
        { countryRegion: [] },
        {}
      );

      if (citiesResp?.done && citiesResp?.response?.rows?.length) {
        allCities = [
          ...Array.from(new Set(
            citiesResp.response.rows.flatMap((row: { cities: any; }) => row.cities || [])
          )),
        ].map(String).sort((a: string, b: string) => a.localeCompare(b));
      }
    } else {
      // get cities for all states
      const citiesResp = await context.apis.public.getHpCitiesByState(
        context.validator,
        { states: allStates },
        {}
      );

      if (citiesResp?.done && citiesResp?.response?.rows?.length) {
        allCities = [
          ...Array.from(new Set(
            citiesResp.response.rows.flatMap((row: { cities: any; }) =>
              (row.cities || []).map((c: { city: any; }) => c.city)
            )
          )),
        ].filter(Boolean).sort((a: string, b: string) => a.localeCompare(b));
      }
    }

    // Use Level 2 API to check which cities have images
    const resp = await context.apis[context.user.role].getAllLevel2CityImages(
      context.validator,
      {
        args: {},
        options: {
          page: 1,
          limit: 1000, // Get all cities with images
          withCount: true
        }
      }
    );

    // Create a map of cities that have images from Level 2 API
    // Also extract unique city names from Level 2 API response
    const cityImagesMap = new Map();
    const citiesFromLevel2 = new Set<string>();
    
    if (resp?.done && resp?.response?.rows && Array.isArray(resp.response.rows) && resp.response.rows.length > 0) {
      resp.response.rows.forEach((row: any) => {
        const cityName = row.city;
        const hasImages = row.images_path && Array.isArray(row.images_path) && row.images_path.length > 0;
        const isPDFcreated = row.isPDFcreated || false;
        
        if (cityName) {
          citiesFromLevel2.add(cityName);
          
          // If city has images, mark it as PDF available
          if (hasImages) {
            cityImagesMap.set(cityName, {
              hasImages: true,
              isPDFcreated: isPDFcreated
            });
          } else if (!cityImagesMap.has(cityName)) {
            // Only set to false if not already set
            cityImagesMap.set(cityName, {
              hasImages: false,
              isPDFcreated: false
            });
          }
        }
      });
    }

    // Use cities from Level 2 API if available, otherwise fall back to allCities
    const citiesToUse = citiesFromLevel2.size > 0 
      ? Array.from(citiesFromLevel2).sort((a: string, b: string) => a.localeCompare(b))
      : allCities;

    const cityDatas = citiesToUse.map((cityName, idx) => {
      const cityData = cityImagesMap.get(cityName);
      return {
        _id: `city_${idx + 1}`,
        city: cityName,
        // PDF is available if city has images in database
        isPDFCreated: cityData?.hasImages === true || cityData?.isPDFcreated === true,
      };
    });

    const transformedData = cityDatas.map((city) => ({
      _id: city._id,
      albumTitle: "HP Smart Champs City Level Finale Album",
      isPDFCreated: city.isPDFCreated,
    }));

    const totalPages = Math.ceil(transformedData.length / dataPerPage);
    setTotalPage(Array.from({ length: totalPages }, (_, i) => i));
    setCityList(citiesToUse);
    setCityWiseData(
      cityDatas.map((c) => ({
        name: c.city,
        isPDFCreated: c.isPDFCreated,
      }))
    );

  } catch (error) {
    console.error("Error fetching Level 2 data:", error);
    setSalesViewData([]);
    setLocation("");
    setTotalPage([0]);
  } finally {
    setIsLoading(false);
  }
};


  const onPageChange = (page) => {
    setCurrentpage(page);
  };

  const onNextClick = () => {
    setCurrentpage(currentPage + 1);
  };

  const onPrevClick = () => {
    setCurrentpage(currentPage - 1);
  };
  const handleCityWiseDownload = async (cityName) => {
    setIsLoading(true);

    try {
      let resp = await context.apis[context.user.role].triggerPendingPDFGenerationCityWiseLevel(
        context.validator,
        { cityName }
      );
      
      // Check multiple possible response structures
      const pdfUrl = resp?.pdfSignedUrl?.image || resp?.signedUrl || resp?.response?.signedUrl || resp?.response?.pdfSignedUrl?.image;
      
      if (pdfUrl) {
        setIsLoading(false);
        window.open(pdfUrl);
      } else {
        setIsLoading(false);
        alert(`No Records Found for this city. ${resp?.message || ''}`);
      }
    } catch (error) {
      setIsLoading(false);
      alert(`Error generating PDF: ${error.message || 'Unknown error'}`);
    }
  };

  const handleCityView = async (cityName) => {
    setIsLoading(true);
    
    try {
      // Use Level 2 API to get images for a specific city
      let resp = await context.apis[context.user.role].getLevel2CityImagesByCity(
        context.validator,
        {
          args: { city: cityName },
          options: {}
        }
      );
      
      if (resp?.done && resp?.response?.rows?.length) {
        // Get all images from all rows for this city (in case there are multiple date entries)
        // The backend now returns signed URLs directly in images_path
        const allImages: string[] = [];
        resp.response.rows.forEach((row: any) => {
          if (row.images_path && Array.isArray(row.images_path)) {
            allImages.push(...row.images_path);
          }
        });

        // Transform image URLs (backend returns signed URLs directly)
        const transformedImages = allImages.slice(0, 50).map((imgUrl, i) => {
          // Backend returns signed URLs from S3, so use them directly
          return {
            _id: `img_${cityName}_${i}`,
            image: imgUrl,
            imageMt: imgUrl,
            status: "approved",
            approvalStatus: "approved",
            uploadedBy: "system",
            uploadedOn: new Date().toISOString(),
            description: "City activity image",
            placementName: cityName,
          };
        });
        
        const transformed = [
          {
            _id: `${cityName}`,
            schoolName: cityName,
            location: cityName,
            city: cityName,
            totalImages: allImages.length,
            schoolCount: 0,
            inventoryCount: 0,
            images: transformedImages,
          },
        ];
        setSalesViewData(transformed);
        setSortAlbumDataBy("gallery");
        setSelectedCities([cityName]);
      } else {
        setSalesViewData([]);
        alert("No images found for this city");
      }
    } catch (error) {
      console.error("Error fetching city images:", error);
      setSalesViewData([]);
      alert("Error loading city images");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className={`ovelap ${overlay ? "active" : ""}`}></div>
      <div className="col-xl-10 col-lg-12 col-md-12 col-xs-12">
        <div className="rightPart noBack">
          <div className="row">
            <BackendTopBar
              from={context.user.role === "backendFOS" && "campaignReporting"}
              redirectPage={false}
            />
            {isLoading ? (
              <Loader />
            ) : (
                <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mb-10 mt-20">
                 {sortAlbumDataBy === "cities" && (
                   <>
                     <h2 className="htx2 clearfix mb-20">
                       Reporting and Monitoring
                     </h2>
                     <div
                       style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                     >
                       <ul className={`tabsinventory`}>
                         <li onClick={() => setSortAlbumDataBy("cities")}>
                            <a
                              href="javascript:void(0);"
                              className={
                                sortAlbumDataBy === "cities" ? "active" : ""
                              }
                            >
                             Cities
                            </a>
                          </li>
                         
                       </ul>
                       <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                       </div>
                     </div>
                   </>
                 )}
                  <div className="faq-view">
                   <div className="faq-tabs-list">
                     {sortAlbumDataBy === "gallery" ? (
                       // Show gallery view with back button
                       <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                          <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", marginBottom: "40px", marginTop: "-15px" }}>
                            <div 
                              onClick={() => setSortAlbumDataBy("cities")}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                cursor: "pointer",
                                fontSize: "18px",
                                fontWeight: "600",
                                color: "#333",
                                marginTop: "15px"
                              }}
                            >
                              <img 
                                src={backIcon}
                                alt="Back"
                                style={{
                                  width: "16px",
                                  height: "16px"
                                }}
                              />
                              Back to Cities
                            </div>
                          </div>
                         
                       {salesViewData.length > 0 &&
                       (() => {
                         const mappedImages = salesViewData[0].images.map((imgObj) => ({
                           ...imgObj,
                           image: imgObj.image || imgObj.imageMt,
                           imageMt: imgObj.imageMt || imgObj.image,
                           approvalStatus: imgObj.approvalStatus || "approved",
                         }));
                         
                         return (
                           <InventoryReport
                             ref={ref}
                             inventoryIndex={0}
                             inventory={{
                               _id: salesViewData[0]._id || "city_gallery",
                               images: mappedImages,
                             schoolName:
                               (salesViewData[0] && (salesViewData[0].schoolName || salesViewData[0].city)) || "",
                             location:
                               (salesViewData[0] && (salesViewData[0].location || location)) || "",
                           }}
                           formData={formData}
                           setFormData={setFormData}
                           schoolId={schoolId}
                           campaignId={campaignId}
                           setRefetch={setRefetch}
                           refetch={refetch}
                           setShowButtons={setShowButtons}
                           showButtons={showButtons}
                           setActiveSetindex={setActiveSetIndex}
                           setActiveImageIndex={setActiveImageIndex}
                           setActiveInventoryIndex={setActiveInventoryIndex}
                           activeSetIndex={activeSetIndex}
                           activeInventoryIndex={activeInventoryIndex}
                           activeImageIndex={activeImageIndex}
                           multiSelectInventories={multiSelectInventories}
                           setMultiSelectInventories={setMultiSelectInventories}
                           groupBy={sortAlbumDataBy}
                           view={"campaignReportView"}
                           campaignLocation={location}
                         />
                         );
                       })()}

                       </div>
                     ) : (
                       // Show city-wise table view
                       <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                          <div className="inventory-tableTabs">
                            <div className="table-container table-inventory mt-10">
                              {loadingCities ? (
                                <div style={{ textAlign: "center", padding: "40px" }}>
                                  <div className="loader-imgupload"></div>
                                  <p style={{ marginTop: "10px", color: "#666" }}>Loading cities data...</p>
                               </div>
                              ) : cityWiseData.length === 0 ? (
                                <div style={{ textAlign: "center", padding: "40px" }}>
                                  <p style={{ color: "#666" }}>No cities data available</p>
                             </div>
                              ) : (
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th scope="col" style={{ width: "10%", textAlign: "center" }}>SL No</th>
                                      <th scope="col" style={{ width: "70%", textAlign: "left" }}>City Name</th>
                                      <th scope="col" style={{ width: "20%", textAlign: "center" }}>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {cityWiseData.map((city, index) => (
                                      <tr key={index}>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{index + 1}</td>
                                        <td style={{ textAlign: "left", verticalAlign: "middle" }}>
                                          <div className="schoolNameTable">
                                            <h4 style={{ margin: "0", fontSize: "16px", fontWeight: "500" }}>
                                              {city.name.split(' ').map(word => 
                                                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                              ).join(' ')}
                                            </h4>
                               </div>
                                       
                                          </td>
                                        
                                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                            { city.isPDFCreated && (
                                            <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
                                              <img 
                                                src={viewIcon}
                                                alt="View Gallery"
                                                onClick={() => handleCityView(city.name)}
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                  cursor: "pointer",
                                                  transition: "transform 0.2s ease"
                                                }}
                                                title={`View gallery for ${city.name}`}
                                                onMouseEnter={(e) => {
                                                  const target = e.target as HTMLImageElement;
                                                  target.style.transform = "scale(1.1)";
                                                }}
                                                onMouseLeave={(e) => {
                                                  const target = e.target as HTMLImageElement;
                                                  target.style.transform = "scale(1)";
                                                }}
                                              />
                                              <img 
                                                src={downloadIcon}
                                                alt="Download PDF"
                                                onClick={() => handleCityWiseDownload(city.name)}
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                  cursor: "pointer",
                                                  transition: "transform 0.2s ease"
                                                }}
                                                title={`Download PDF for ${city.name}`}
                                                onMouseEnter={(e) => {
                                                  const target = e.target as HTMLImageElement;
                                                  target.style.transform = "scale(1.1)";
                                                }}
                                                onMouseLeave={(e) => {
                                                  const target = e.target as HTMLImageElement;
                                                  target.style.transform = "scale(1)";
                                                }}
                                              />
                                            </div>
                                            )}
                                          </td>
                                       
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                           </div>
                         </div>
                       </div>
                     )}
                   </div>
                 </div>
                 
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CampaignCompetitionReportingViewLevel2;
